module.exports = __webpack_public_path__ + "img/1_character.1c7fe2c8.png";